import { useEffect, useState } from 'react';
import axios from 'axios';
import Spinner from '../../components/Spinner';

const annoCorrente = new Date().getFullYear();

export default function TabellaInail() {
  const [righe, setRighe] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ anno: annoCorrente, importo: '' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  function carica() {
    axios.get('/api/tabella-inail')
      .then(r => setRighe(r.data))
      .finally(() => setLoading(false));
  }

  useEffect(() => { carica(); }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    setMsg('');
    try {
      await axios.post('/api/tabella-inail', form);
      setMsg('Salvato!');
      carica();
    } catch {
      setMsg('Errore nel salvataggio');
    } finally {
      setSaving(false);
    }
  }

  async function elimina(id) {
    if (!window.confirm('Eliminare questo importo?')) return;
    await axios.delete(`/api/tabella-inail/${id}`);
    carica();
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-[#1A3A5C] mb-2">Tabella INAIL</h1>
      <p className="text-sm text-gray-500 mb-6">
        Importo annuo della retribuzione convenzionale INAIL per titolari/soci.
        Usato nel calcolo del costo del personale per ditte individuali e SNC.
      </p>

      <div className="bg-white rounded-xl shadow p-5 mb-6">
        <h2 className="font-semibold text-[#1A3A5C] mb-4">Aggiungi / aggiorna anno</h2>
        <form onSubmit={handleSubmit} className="flex flex-wrap items-end gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Anno</label>
            <input
              type="number"
              min="2000"
              max="2100"
              value={form.anno}
              onChange={e => setForm(f => ({ ...f, anno: parseInt(e.target.value) }))}
              className="w-24 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#2E6096]"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Importo (€)</label>
            <input
              type="number"
              step="0.01"
              required
              placeholder="es. 15576.00"
              value={form.importo}
              onChange={e => setForm(f => ({ ...f, importo: e.target.value }))}
              className="w-36 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#2E6096]"
            />
          </div>
          <button
            type="submit"
            disabled={saving}
            className="bg-[#1A3A5C] text-white px-5 py-2 rounded-lg text-sm font-medium hover:bg-[#2E6096] transition disabled:opacity-50"
          >
            {saving ? 'Salvo...' : 'Salva'}
          </button>
          {msg && <span className={`text-sm ${msg.includes('Errore') ? 'text-red-600' : 'text-green-600'}`}>{msg}</span>}
        </form>
      </div>

      {loading ? <Spinner /> : (
        <div className="bg-white rounded-xl shadow overflow-hidden">
          {righe.length === 0 ? (
            <p className="text-center text-gray-500 py-10">Nessun importo inserito</p>
          ) : (
            <table className="w-full text-sm">
              <thead className="bg-[#EEF4FB] text-[#1A3A5C] font-semibold">
                <tr>
                  <th className="text-left px-4 py-3">Anno</th>
                  <th className="text-right px-4 py-3">Importo €</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody>
                {righe.map((r, i) => (
                  <tr key={r.id} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="px-4 py-2.5 font-medium">{r.anno}</td>
                    <td className="px-4 py-2.5 text-right">{r.importo.toLocaleString('it-IT', { minimumFractionDigits: 2 })}</td>
                    <td className="px-4 py-2.5 text-right">
                      <button onClick={() => elimina(r.id)} className="text-red-500 hover:underline text-xs">Elimina</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
